import { render, staticRenderFns } from "./AppointmentCalendar.vue?vue&type=template&id=27925c84&scoped=true&"
import script from "./AppointmentCalendar.vue?vue&type=script&lang=ts&"
export * from "./AppointmentCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentCalendar.vue?vue&type=style&index=0&id=27925c84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27925c84",
  null
  
)

export default component.exports